import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import MediaLibraryView from './MediaLibraryView';
import AppSnackbar from '../ui/AppSnackbar';
import { snackbarDoAviso } from './mediaLibraryVmBuilder';

/** Acima do rodapé fixo da janela (a fila escolhida + "Adicionar"): no celular o aviso não cobre o botão. Medida do CD. */
const ACIMA_DO_RODAPE = { bottom: { xs: 132, sm: 104 } };

/**
 * MediaLibrary — a biblioteca de imagens inteira: a View (Claude Design) + o aviso efêmero, que é da casa (`AppSnackbar`)
 * e por isso fica aqui, não na View (mesmo caso do PagesView). Usado pelo bloco Galeria e pelo campo Logo.
 *   <MediaLibrary vm={library.vm} actions={library.actions} />   // library = useMediaLibrary(...)
 */
const MediaLibrary = ({ vm, actions }) => {
  const aviso = vm.open ? vm.notice : null;
  const ultimo = useRef(null);
  useEffect(() => { if (aviso) ultimo.current = aviso; }, [aviso]);

  return (
    <>
      <MediaLibraryView vm={vm} actions={actions} />
      <AppSnackbar
        snackbar={snackbarDoAviso(aviso, ultimo.current)}
        // Toque fora (clickaway) não fecha: a janela continua em uso e o aviso some sozinho em 5 s.
        onClose={(_, motivo) => { if (motivo !== 'clickaway') actions.onDismissNotice?.(); }}
        autoHideDuration={5000}
        sx={ACIMA_DO_RODAPE}
      />
    </>
  );
};

MediaLibrary.propTypes = {
  vm: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

export default MediaLibrary;
